import tableCreatorCreatorFactoryCreator from '../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'
import BayphoneUserMinimalTableTableCreator from '../../tableDefinitions/Bayphone/BayphoneUserMinimalTableTableCreator'

export default class BayphoneUserMinimalTable {
    constructor(filters) {
        this.filters = filters
        this.tableFormMapper = [
            {mapper:data=>data.user.enterpriseId, label:"ID"},
            {mapper:data=>data.user.firstName, label:"First Name"},
            {mapper:data=>data.user.lastName, label:"Last Name"},
            {mapper:data=>data.user.email, label:"Email"}
        ]
    }

    getTableCreator = () => {
        var tableCreatorCreator = tableCreatorCreatorFactoryCreator.getTableCreatorCreatorFromIdentifier(BayphoneUserMinimalTableTableCreator.getId(), {tcFilters: this.filters})
        return tableCreatorCreator.getTableCreator('Bayphone User')
    }
}